import React from 'react'
import { Navigate } from 'react-router-dom'
import userStorage from 'services/userStorage'
import { Roles } from 'utils/enums'

const Redirector = () => {
  const user = userStorage.getUser()
  const mainPath = Roles[user?.role]?.mainPath
  const path = mainPath ? `/${mainPath}` : '/login'
  return (
    <Navigate to={path} />
  )
}

export default Redirector
